import {Button} from '@mui/material'
import {Form, Input, Select} from 'antd'
import {FormattedMessage} from 'react-intl'
import PrimaryButton from 'src/components/elements/Buttons/PrimaryButton/PrimaryButton'
import SecondaryButton from 'src/components/elements/Buttons/SecondaryButton/SecondaryButton'
import DialogCustom from 'src/components/elements/DialogCustom/DialogCustom'
import {CalendarEvent} from '../Calendar/Calendar'
import {useState, useEffect} from 'react'
import Icon from '@mdi/react'
import {mdiClose, mdiMagnify} from '@mdi/js'
import PatientLookupDialog from '../PatientLookupDialog/PatientLookupDialog'
import {EchocardiographicRequestDialogStyled} from './EchocardiographicRequestDialogStyled'
import TextArea from 'antd/lib/input/TextArea'

type EchocardiographicRequestDialogProps = {
  onClose: () => void,
  onSave: (values: CalendarEvent) => void,
  readOnly?: boolean,
  initialValues?: Record<string, any>
};

const EchocardiographicRequestsRequestDialog: React.FC<EchocardiographicRequestDialogProps> = ({
  onClose,
  onSave,
  readOnly = false,
  initialValues = {}
}) => {
  const [form] = Form.useForm()
  const [isPatientsModal, setIsPatientsModal] = useState<boolean>(false)
  const [currentUser, setCurrentUser] = useState<Record<string, any>>(initialValues.user)

  useEffect(() => {
    console.log('initialValues', initialValues)
    form.setFieldsValue(initialValues)
  }, [initialValues, form])

  const onFinish = (values: any) => {
    onSave({
      ...values,
      user: currentUser
    })
  }

  const body = (
    <EchocardiographicRequestDialogStyled>
      <Form
        form={form}
        id='organize-form'
        layout='vertical'
        onFinish={onFinish}
      >
        <Form.Item
          className='title'
          label='Titolo'
          name='title'
          rules={[{required: true, message: 'Campo obbligatorio'}]}
        >
          <Input disabled={readOnly} />
        </Form.Item>
        <Form.Item
          className='examType'
          initialValue='eco'
          label='Tipo Esame'
          name='examType'
          rules={[{required: true, message: 'Campo obbligatorio'}]}
        >
          <Select
            allowClear
            disabled={readOnly}
            getPopupContainer={(trigger) => trigger}
            options={[{label: 'ECO', value: 'eco'}]}
          />
        </Form.Item>
        <Form.Item
          className='description'
          label='Descrizione'
          name='description'
        >
          <TextArea disabled={readOnly} />
        </Form.Item>
        {!readOnly ? (
          <Form.Item
            className='patient'
            label='Paziente'
          >
            <div className='patient-content'>
              <Form.Item
                name='user'
                rules={[{required: true, message: 'Campo obbligatorio'}]}
              >
                <Input disabled />
              </Form.Item>
              <div className='patient-buttons'>
                <Button
                  className='patient-button'
                  onClick={() => setIsPatientsModal(true)}
                >
                  <Icon path={mdiMagnify} size={1} />
                </Button>
                <Button
                  className='patient-button'
                  disabled={currentUser === undefined}
                  onClick={() => form.setFieldValue('user', undefined)}
                >
                  <Icon path={mdiClose} size={1} />
                </Button>
              </div>
            </div>
          </Form.Item>
        ) : (
          <Form.Item
            className='patient'
            label='Paziente'
            name='patient'
          >
            <Input disabled={readOnly} />
          </Form.Item>
        )}
      </Form>
    </EchocardiographicRequestDialogStyled>
  )

  const footer = !readOnly && (
    <div style={{display: 'flex', width: '100%'}}>
      <PrimaryButton
        form='organize-form'
        key='submit'
        type='submit'
      >
        <FormattedMessage id='save' />
      </PrimaryButton>
      <SecondaryButton onClick={onClose}>
        <FormattedMessage id='undo' />
      </SecondaryButton>
    </div>
  )

  return (
    <>
      <DialogCustom
        body={body}
        footer={footer}
        maxWidth='xl'
        onClose={onClose}
        title={{text: readOnly ? 'detail' : 'request', format: true}}
      />
      {isPatientsModal &&
        <PatientLookupDialog
          onClose={() => setIsPatientsModal(false)}
          onRowClick={(row) => {
            setCurrentUser(row)
            form.setFieldValue('user', `${row.firstName} ${row.lastName}`)
            form.setFieldValue('email', row.email)
            setIsPatientsModal(false)
          }}
        />}
    </>
  )
}

export default EchocardiographicRequestsRequestDialog
